<template>
</template>

<script>
    import ButtonControlMixin from '../mixins/ButtonControlMixin';
    import Attribution from 'ol/control/Attribution';

    export default {
        mixins: [
            ButtonControlMixin
        ],
        data()
        {
            return {
                idPanel: 'attribution',
                className: 'ol-attribution',
            }
        },
        methods:
        {
            addButtonMap: function(_map){
                let panel = _map.getPanel(this.posBtnMap, {'subposition': this.subPosBtnMap});
                if(panel) {
                    let ctrl = new Attribution({
                        tipLabel: this.title,
                        className: _map.getControlClassName(this.orderClassName),
                        target: panel.getElement(this.subPosBtnMap),
                        label: 'i',
                        collapsible: false
                    });
                    _map.addControlOL(ctrl);
                    return ctrl;
                }
                return false;
            },
        }

    }
</script>

<style lang="scss" scoped>
</style>